import Spinner from './Spinner';

export type { SpinnerProps } from './Spinner';
export default Spinner;
